// src/pages/BookingTypesPage.js

import React from 'react';

const BookingTypesPage = () => {
  return (
    <div>
      <h1>Booking Types</h1>
      <p>This is the Booking Types management page. Here you can view and manage different types of bookings available in your hotel system.</p>

      {/* Dummy list of booking types */}
      <ul>
        <li>Standard Booking</li>
        <li>Advance Booking</li>
        <li>Last-Minute Booking</li>
        <li>Non-Refundable Booking</li>
        <li>Flexible Booking</li>
      </ul>

      <button>Add New Booking Type</button>
    </div>
  );
};

export default BookingTypesPage;
